const config = {
    apiKey: "AIzaSyAyENIaTkhBb4tKP8D11MjGYU-QoakZ9kg",
    authDomain: "cooperei-app.firebaseapp.com",
    databaseURL: "https://cooperei-app.firebaseio.com",
    projectId: "cooperei-app",
    storageBucket: "cooperei-app.appspot.com",
    messagingSenderId: "252958093974",
}

export default config